function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { nameToInitials } from "common/util/string";
import { TooltipEl } from "common/components/tooltip";
import emptyIconImage from "./empty-icon.svg";
import mpAvatarUrl from "./mp-avatar.svg";
const ImageIcon = (_ref) => {
  let {
    src,
    iconSize,
    handleAvatarImageLoaded,
    elref,
    isAvatarImageLoaded = true,
    isStaffIcon = false
  } = _ref;
  return /* @__PURE__ */ jsx("div", { sel: ".image-icon.color-avatar", class: {
    loading: !isAvatarImageLoaded
  }, "data-sentry-component": "ImageIcon", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("img", { attrs: {
    elref,
    align: "middle",
    src,
    loading: "lazy"
  }, style: _objectSpread({
    height: isStaffIcon ? "".concat(iconSize * (2 / 3), "px") : "".concat(iconSize, "px"),
    width: isStaffIcon ? "".concat(iconSize * (2 / 3), "px") : "".concat(iconSize, "px")
  }, isStaffIcon ? {
    margin: "".concat(iconSize / 6, "px")
  } : {}), on: {
    load: handleAvatarImageLoaded
  } }));
};
const InitialsIcon = (_ref2) => {
  let {
    name,
    backgroundClassName
  } = _ref2;
  return /* @__PURE__ */ jsx("div", { class: {
    [backgroundClassName]: true,
    "initials-icon": true
  }, attrs: {
    elref: "initialsIcon"
  }, "data-sentry-component": "InitialsIcon", "data-sentry-source-file": "template.tsx" }, nameToInitials(name));
};
const Placeholder = (_ref3) => {
  let {
    userIcon,
    iconSize,
    name
  } = _ref3;
  if (name) {
    return /* @__PURE__ */ jsx(InitialsIcon, { name, backgroundClassName: userIcon.helpers.getBackgroundColorClass() });
  }
  return /* @__PURE__ */ jsx(ImageIcon, { src: emptyIconImage, iconSize, isAvatarImageLoaded: true, elref: "defaultImg", "data-sentry-element": "ImageIcon", "data-sentry-component": "Placeholder", "data-sentry-source-file": "template.tsx" });
};
const Avatar = (_ref4) => {
  let {
    userIcon,
    iconSize,
    name
  } = _ref4;
  const avatarUrl = userIcon.helpers.getAvatarUrl();
  const {
    isAvatarImageLoaded
  } = userIcon.state;
  if (avatarUrl) {
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ImageIcon, { src: avatarUrl, iconSize, isAvatarImageLoaded, elref: "userImg", handleAvatarImageLoaded: userIcon.helpers.handleAvatarImageLoaded, isStaffIcon: userIcon.shouldShowStaffAvatar() }), isAvatarImageLoaded ? null : /* @__PURE__ */ jsx(Placeholder, { userIcon, iconSize, name }));
  }
  return /* @__PURE__ */ jsx(Placeholder, { userIcon, iconSize, name, "data-sentry-element": "Placeholder", "data-sentry-component": "Avatar", "data-sentry-source-file": "template.tsx" });
};
export function template() {
  const {
    iconSize,
    fontSize
  } = this.helpers.getIconProperties();
  const name = this.helpers.getDisplayName();
  const labelPrefix = this.attr("label-prefix");
  const labelSuffix = this.attr("label-suffix");
  const label = "".concat(labelPrefix, " ").concat(name, " ").concat(labelSuffix).trim();
  return /* @__PURE__ */ jsx("div", { class: {
    clickable: this.helpers.shouldOpenSidebar(),
    container: true
  }, attrs: {
    tabindex: 0
  }, on: {
    click: this.helpers.handleIconClick,
    keypress: this.helpers.handleIconClick
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".avatar-container", style: {
    "font-size": "".concat(fontSize, "px"),
    height: "".concat(iconSize, "px"),
    "line-height": "".concat(iconSize, "px"),
    width: "".concat(iconSize, "px"),
    "min-width": "".concat(iconSize, "px")
  }, class: {
    "is-staff-member-image": !!this.attr("staff-member-avatar-uuid"),
    offline: this.attr("is-offline")
  } }, /* @__PURE__ */ jsx(Avatar, { userIcon: this, iconSize, name, "data-sentry-element": "Avatar", "data-sentry-source-file": "template.tsx" }), this.attr("staff-member-avatar-uuid") && /* @__PURE__ */ jsx("img", { sel: ".staff-member-image-overlay", attrs: {
    src: mpAvatarUrl
  } })), !this.attr("disable-tooltip") && this.attr("name") && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: this.attr("tooltip-placement"),
    offset: 12
  } }, labelPrefix && /* @__PURE__ */ jsx("div", { sel: ".tooltip-subtitle" }, labelPrefix), /* @__PURE__ */ jsx("div", { sel: ".tooltip-text" }, name), labelSuffix && /* @__PURE__ */ jsx("div", { sel: ".tooltip-subtitle" }, labelSuffix)), this.attr("include-label") ? /* @__PURE__ */ jsx("div", { sel: ".label", attrs: {
    elref: "label"
  }, style: {
    "line-height": "".concat(iconSize, "px")
  } }, label) : null);
}
